import {
	APPLICATION_PARAM,
	APP_ANCHOR,
	OPTIMIZATION_PARAM,
	SELECTED_TAB_PARAM,
	SENSOR_TYPE_PARAM,
	SOLUTION_ID_PARAM,
} from '../config/app';

/**
 * Fetches selected filter and selected tab values from url params and returns them
 * @returns {object} Object containing selected 'application', 'sensorType'
 * 'optimization' filter values, selected tab, and 'solutionId' if present, null if not
 */
export const getAppSelectionsFromUrlParams = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const application = urlParams.get(APPLICATION_PARAM);
	const sensorType = urlParams.get(SENSOR_TYPE_PARAM);
	const optimization = urlParams.get(OPTIMIZATION_PARAM);
	const solutionId = urlParams.get(SOLUTION_ID_PARAM);
	const selectedTab = urlParams.get(SELECTED_TAB_PARAM);

	if (application && sensorType && optimization && solutionId) {
		return {
			selectedFilters: { application, sensorType, optimization, solutionId },
			selectedTab,
		};
	}
	return { selectedFilters: null, selectedTab };
};

/**
 * Sets url search params with the updated solution filter values,
 * and also sets the app anchor as url hash (if not already present)
 * @param {object} updatedFilters Object containing updated 'application', 'sensorType',
 * @param {string} selectedTab 'Schematic', 'evalKits' or 'samples' tab
 * 'optimization' filter values, and selected 'solutionId'
 */
export const updatePageUrl = (updatedFilters, selectedTab) => {
	if (!updatedFilters || !selectedTab) return;

	const url = new URL(window.location.href);
	const { application, sensorType, optimization, solutionId } = updatedFilters;

	url.search = ''; // Remove all unwanted or potentially invalid url params

	url.searchParams.set(APPLICATION_PARAM, application);
	url.searchParams.set(SENSOR_TYPE_PARAM, sensorType);
	url.searchParams.set(OPTIMIZATION_PARAM, optimization);
	url.searchParams.set(SOLUTION_ID_PARAM, solutionId);
	url.searchParams.set(SELECTED_TAB_PARAM, selectedTab);

	url.hash = APP_ANCHOR;

	window.history.pushState({}, '', url);
};

/**
 * Copies the passed url to clipboard
 * @param {string} url Url to be copied to clipboard
 */
export const copyUrlToClipboard = async (url = '') => {
	try {
		await navigator.clipboard.writeText(url);
	} catch (error) {
		console.error('Error occurred while copying url to clipboard:', error);
	}
};

/**
 * Retrieves the file extension from its absolute url
 * @param {string} fileUrl File url whose extension needs to be found
 * @returns {string} Extension of the file (For example, PDF, ASC, ZIP etc.)
 */
export const getFileExtensionFrom = fileUrl => {
	return (
		fileUrl
			?.match(/(\.)[a-z]+/gi)
			?.slice(-1)[0]
			?.slice(1)
			.toUpperCase() ?? 'NA'
	);
};
